import { useController, useFormContext } from 'react-hook-form';
import { useEffect } from 'react';
import { InputField, RadioGroupField } from 'lib/iterable-hook-form';
import { FormField } from 'ui/formField';
import {
  CONTENT,
  CRITERIA_DESCRIPTION_MAX_LENGTH,
  CRITERIA_NAME_MAX_LENGTH,
  LIVE_STATUS_OPTIONS,
} from '../constants';
import { useQueryActiveCriteriaCount } from '../hooks/useQueryActiveCriteriaCount';
import { CriteriaCreateFormFields } from '../types';

export const CriteriaCreateForm = () => {
  const { limitReached } = useQueryActiveCriteriaCount();
  const { setValue } = useFormContext();

  useEffect(() => {
    // If limit on live criteria has been reached we want to set the form value to the false equivalent and disable the form field
    if (limitReached) {
      setValue(CriteriaCreateFormFields.IS_LIVE, 'false');
    }
  }, [limitReached]);

  const {
    fieldState: { error: nameError },
  } = useController({
    name: CriteriaCreateFormFields.NAME,
  });
  return (
    <>
      <FormField
        labelText={CONTENT.createCriteriaForm.nameLabel}
        isHorizontalLayout
        hasError={!!nameError}
        errorText={nameError?.message}
        isRequired
      >
        <InputField
          data-test="create-criteria-form-input-field-name"
          name="name"
          maxLength={CRITERIA_NAME_MAX_LENGTH}
        />
      </FormField>
      <FormField
        labelText={CONTENT.createCriteriaForm.descriptionLabel}
        isRequired={false}
        isHorizontalLayout
        restrictionText="(Optional)"
      >
        <InputField name="description" maxLength={CRITERIA_DESCRIPTION_MAX_LENGTH} />
      </FormField>
      <FormField
        isDisabled={limitReached}
        labelText={CONTENT.createCriteriaForm.autoEnableLabel}
        isHorizontalLayout
      >
        <RadioGroupField
          isReadOnly={limitReached}
          name="isLive"
          options={LIVE_STATUS_OPTIONS}
          radioAlignment="flex-start"
        />
      </FormField>
    </>
  );
};
